import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";

// Reducers
import userReducer from "./Slices/User/userSlice";
import accessorReducer from "./Slices/Accessor/accessorSlice";
import adminReducer from "./Slices/Admin/adminSlice";
import commonReducer from "./Slices/Common/commonSlice";
import approverReducer from "./Slices/Approver/approverSlice";
import userReportReducer from "./Slices/User/reportSlice";
import matrixAnswerReducer from "./Slices/User/matrixAnswers";
import rearrangeAnswerReducer from "./Slices/User/rearrange";
import greaseAnswerReducer from "./Slices/User/greaseAnswers"
import notificationsReducer from "./Slices/Common/notificationSlice";
import sparePartsSlice from "./Slices/Accessor/sparePartsSlice";
import sparePartUploaderSlice from "./Slices/Accessor/sparePartUploaderSlice";
import persistConfig from "./persistConfig";
import storage from "redux-persist/lib/storage";

// Configure persisted reducers
const persistedUserReducer = persistReducer(persistConfig, userReducer);
const persistedAccessorReducer = persistReducer(
  { key: "accessor", storage },
  accessorReducer
);

const persistedAdminReducer = persistReducer(persistConfig, adminReducer);
const persistedCommonReducer = persistReducer(persistConfig, commonReducer);
const persistedApproverReducer = persistReducer(persistConfig, approverReducer);
// const persistedMatrixAnswerReducer = persistReducer(persistConfig, matrixAnswerReducer);
// const persistedGreaseAnswerReducer = persistReducer(persistConfig, greaseAnswerReducer);
// Create the Redux store
const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    accessor: persistedAccessorReducer,
    admin: persistedAdminReducer,
    common: persistedCommonReducer,
    report: userReportReducer,
    notification: notificationsReducer,
    approver: persistedApproverReducer,
    spareParts: sparePartsSlice,
    sparePartUploader: sparePartUploaderSlice,
    matrixAnswers : matrixAnswerReducer,
    greaseAnswers :  greaseAnswerReducer,
    rearrange : rearrangeAnswerReducer,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check if needed
    }),
    devTools: process.env.NODE_ENV !== "production", 
});

const persistor = persistStore(store);

// Exporting store and persistor
export default store;
export { persistor };
